<template>
    <div></div>
</template>

<script>
    /**
     * As you can see, it's surely an empty block =))
     */
    export default {
        name: "EmptyBlockControl"
    }
</script>